export const DOT_DATE_REGEX = /^(\d{2})\.(\d{2})\.(\d{4})$/;
export const ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})/;

const buildLocalDate = (year, monthIndex, day) => {
    const date = new Date(year, monthIndex, day);
    if (date.getFullYear() !== year || date.getMonth() !== monthIndex || date.getDate() !== day) return null;
    return date;
};

export const toDotDateString = date => `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;

export const toIsoDateString = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const parseDateValue = value => {
    if (!value) return null;
    if (value instanceof Date) return value;

    const stringValue = String(value);

    const dotMatch = DOT_DATE_REGEX.exec(stringValue);
    if (dotMatch) {
        return buildLocalDate(Number(dotMatch[3]), Number(dotMatch[2]) - 1, Number(dotMatch[1]));
    }

    const isoMatch = ISO_DATE_REGEX.exec(stringValue);
    if (isoMatch) {
        return buildLocalDate(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const normalizeDateFilterValue = value => {
    const date = parseDateValue(value);
    return date ? toIsoDateString(date) : value;
};
